import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { MIN_USERNAME_LENGTH } from './auth-register'

import type { TransKey } from '@root/shared/localization'
import type { Intent } from '@root/shared/ui-kit'

type AuthRegisterUsernameInfoProps = {
  username: string
  usernameIntent: Exclude<Intent, 'warning'>
}

export const AuthRegisterUsernameInfo: React.FC<
  AuthRegisterUsernameInfoProps
> = ({ username, usernameIntent }) => {
  const { t } = useTranslation()

  return (
    <>
      <span>{t('auth.register.create-any-unique-username')}</span>
      {username.trim().length >= MIN_USERNAME_LENGTH ? (
        <>
          :<br />
          <Trans
            i18nKey={MAP_USERNAME_INTENT_TO_I18N_KEY[usernameIntent]}
            components={[<Root $intent={usernameIntent} key={0} />]}
            values={{ username }}
          />
        </>
      ) : undefined}
    </>
  )
}

const MAP_USERNAME_INTENT_TO_I18N_KEY: Record<
  Exclude<Intent, 'warning'>,
  TransKey
> = {
  success: 'auth.register.create-any-unique-username-available',
  error: 'auth.register.create-any-unique-username-not-available',
  neutral: 'auth.register.create-any-unique-username-checking',
}

const Root = styled.span<{ $intent: Intent }>`
  overflow: hidden;
  word-break: break-all;

  ${({ $intent }) => {
    if ($intent === 'success') {
      return css`
        color: var(--green-9);
      `
    }
    if ($intent === 'error') {
      return css`
        color: var(--down-9);
      `
    }
    return css`
      color: var(--textA-10);
    `
  }}
`
